import { useQuery } from "@tanstack/react-query";
import { downloadMembershipEnrollmentReport } from "../../service/query/auth";

export const useDownloadMembershipReport = ({ payload}) => {
  const membershipEnrollmentReport= useQuery({
    queryKey: ['MembershipEnrollmentForm', payload],
    queryFn: () => downloadMembershipEnrollmentReport({ ...payload }),
    enabled: !!payload,
    keepPreviousData: true,
  },
  
  

);
  return {data:membershipEnrollmentReport?.data?.data,  ...membershipEnrollmentReport,}
};